export const environment = {

  version: 7,
  production: true,
  helpDeskUrl: "https://meds-gateway-api.curebay.com/api-gateway",
  BASE_URL: "https://meds-gateway-api.curebay.com/api-gateway",
  adminUrl: "https://meds-gateway-api.curebay.com/api-gateway",
  pharmaUrl: "https://pharmacy.curebay.com/api",
  adminUrl3: "https://meds-gateway-api.curebay.com/api-gateway",
  hubUrl: "https://meds-gateway-api.curebay.com/api-gateway",
  eagleUrl: 'https://meds-gateway-api.curebay.com/api-gateway/eagle',
  billUrl: "https://meds-gateway-api.curebay.com/api-gateway/eagle",
  bannerUrl: "https://meds-gateway-api.curebay.com/api-gateway",
  onboardUrl: "https://meds-api-common.curebay.com/meds-common",
  qrUrl: "https://lifeline.curebay.com/?retailer=",
  docraptor: { key: "dc8n3N38toneWIGm0qsr", test: false },
  firebase: {
    apiKey: "AIzaSyD3rXgiBEoEMoD2RYitgyrqYCutw4-y97c",
    authDomain: "saveo-ordering-app.firebaseapp.com",
    databaseURL: "https://saveo-ordering-app.firebaseio.com",
    projectId: "saveo-ordering-app",
    storageBucket: "",
    messagingSenderId: "662126699710",
    appId: "1:662126699710:web:29d2e4642721098c"
  }
};
